import { render, staticRenderFns } from "./switch-language.vue?vue&type=template&id=0022931e&scoped=true"
import script from "./switch-language.vue?vue&type=script&setup=true&lang=js"
export * from "./switch-language.vue?vue&type=script&setup=true&lang=js"
import style0 from "./switch-language.vue?vue&type=style&index=0&id=0022931e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022931e",
  null
  
)

export default component.exports